import { ExclusionItemFormWebComponent } from './component/ExclusionItemFormWebComponent';
import { WEB_COMPONENT_EXCLUSION_ITEM_FORM } from '../../webcomponents.constants';

/**
 * The exclusion item form component for adding exclusions
 * @link https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/1153468618/Global+Exclusions+Page
 */
export { ExclusionItemFormWebComponent };

window.customElements.define(WEB_COMPONENT_EXCLUSION_ITEM_FORM, ExclusionItemFormWebComponent);
